export interface IGeneralVariables {
  containerWidth: number
  containerPaddingX: number
  containerPaddingXMd: number
  containerPaddingXSm: number
  borderRadius: string
  boxShadow: string
}

const generalVariables: IGeneralVariables = {
  containerWidth: 1200,
  containerPaddingX: 10,
  containerPaddingXMd: 40,
  containerPaddingXSm: 20,
  borderRadius: '4px',
  boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.05)',
}

export default generalVariables
